import React, { useId } from 'react';
import { Input, Textarea, Select } from '../FormField';

export interface ClientDetailsValues { name: string; email: string; phone: string; notes: string }

interface ClientDetailsSectionProps {
  values: ClientDetailsValues;
  errorFor: (field: keyof ClientDetailsValues) => string | undefined;
  onChange: (patch: Partial<ClientDetailsValues>) => void;
  disabled: boolean;
  /** New client only: the project to link it to. */
  projectChoices?: { value: string; label: string }[];
  projectId?: string;
  onProjectChange?: (projectId: string) => void;
}

/** Name, e-mail, phone and notes of one client, in a titled card like the other record forms. */
const ClientDetailsSection: React.FC<ClientDetailsSectionProps> = ({
  values, errorFor, onChange, disabled, projectChoices, projectId = '', onProjectChange,
}) => {
  const uid = useId();
  return (
    <section className="settings-card ep-section" aria-labelledby={`${uid}-title`}>
      <h2 id={`${uid}-title`} className="ap-section-title">Client details</h2>
      <Input label="Name" required error={errorFor('name')} value={values.name} onChange={e => onChange({ name: e.target.value })} placeholder="e.g. Alex & Sam" disabled={disabled} autoFocus />
      <div className="ap-field-row">
        <Input label="Email" type="email" error={errorFor('email')} value={values.email} onChange={e => onChange({ email: e.target.value })} placeholder="client@example.com" disabled={disabled} />
        <Input label="Phone" type="tel" error={errorFor('phone')} value={values.phone} onChange={e => onChange({ phone: e.target.value })} placeholder="Phone number with country code" disabled={disabled} />
      </div>
      <Textarea label="Notes" error={errorFor('notes')} value={values.notes} onChange={e => onChange({ notes: e.target.value })} rows={4} disabled={disabled} />
      {projectChoices && projectChoices.length > 0 && onProjectChange && (
        <Select label="Link to project" value={projectId} onChange={e => onProjectChange(e.target.value)} placeholder="(optional) select a project" options={projectChoices} />
      )}
    </section>
  );
};

export default ClientDetailsSection;
